import React from 'react';
import { useAuth } from '../AuthProvider';
import { hasPermission } from '../utils/permissions';

const PermissionGate = ({ permission, children, fallback = null }) => {
  const { permissions } = useAuth();
  
  if (!permission || hasPermission(permissions, permission)) {
    return <>{children}</>;
  }
  
  return fallback;
};

export default PermissionGate;



